<div class="container-spinner" [ngClass]="{
  'container-spinner--no-min-height': !loading && withoutMinHeightOnLoaded,
  'container-spinner--min-height': withMinHeight,
  'container-spinner--base': withBaseClass
  }">
  <div class="overlay"
    [ngClass]="{
      overlay: withOverlay && loading
    }"
  >
    <mat-spinner [style.marginTop.px]="radius" [style.marginLeft.px]="radius" [diameter]="diameter" *ngIf="withSpinner && loading"></mat-spinner>
  </div>
  <ng-content></ng-content>
</div>
